import { render, staticRenderFns } from "./KoutsuhiPatternInputPage.vue?vue&type=template&id=09ecca84&scoped=true&"
import script from "./KoutsuhiPatternInputPage.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiPatternInputPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ecca84",
  null
  
)

export default component.exports